import { ReactComponent as EditSVG } from "./edit-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconEdit(props) {
  return <SvgIcon {...props} component={EditSVG} viewBox="0 0 16 16" />;
}